/* Keep Shopify Inbox's launcher clear of the real purchase bar height,
   including safe areas, wrapped text, font loading and orientation changes. */
(() => {
  'use strict';
  const root = document.documentElement;
  let observer;
  function connect() {
    if (observer) observer.disconnect();
    const bar = document.querySelector('.template-product .mobile-purchase-bar');
    if (!bar) {
      root.style.removeProperty('--mpp-purchase-bar-height');
      return;
    }
    const update = () => {
      const height = Math.ceil(bar.getBoundingClientRect().height);
      root.style.setProperty('--mpp-purchase-bar-height', `${height}px`);
    };
    update();
    if ('ResizeObserver' in window) {
      observer = new ResizeObserver(update);
      observer.observe(bar);
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', connect, { once: true });
  } else {
    connect();
  }
  window.addEventListener('resize', connect);
  document.addEventListener('shopify:section:load', connect);
  document.addEventListener('shopify:section:unload', connect);
})();

/* SORT DELEGATION
   Inline onchange attributes do not fire on this storefront, so the sort control
   was inert. Bind it here from an external asset instead, and build the URL
   without touching the global URL constructor, which the theme shadows. */
(() => {
  function applySort(value) {
    var u = window.location.href;
    var p = 'sort_by=' + encodeURIComponent(value);
    if (/[?&]sort_by=[^&]*/.test(u)) {
      u = u.replace(/([?&])sort_by=[^&]*/, '$1' + p);
    } else {
      u += (u.indexOf('?') > -1 ? '&' : '?') + p;
    }
    window.location.href = u;
  }
  document.addEventListener('change', function (e) {
    var el = e.target;
    if (!el || !el.classList || !el.classList.contains('sort-select')) return;
    applySort(el.value);
  }, true);
})();
